// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VOilOsVjUQ_Q1wRJN9Ac{background:rgba(0,0,0,.3);height:100%;left:0;position:absolute;top:0;width:100%;z-index:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackground": `VOilOsVjUQ_Q1wRJN9Ac`
};
export default ___CSS_LOADER_EXPORT___;
